export default "__VITE_ASSET__18891472__"